import axios from 'axios'

const env = (process.env.NODE_ENV === 'production')

const config = () => {
  return {
    url: env ? 'https://fdc-api.brique.kr' : 'http://localhost',
    port: env ? '' : ':'.concat('20004'),
    service: '/fdc/model'
  }
}

export default {
  /**
   * Set-Point Model
   */
  /**
   * @summary Model 단건 조회
   * @description
   * @params : FAB, EQP_ID, MODULE_ID, PARAM_NAME, RECIPE_ID, STEP_ID
   */
  getSetPointModel: async (payload, callback) => {
    let url = config().url.concat(config().port, config().service, '/setpoint-model')

    await axios
      .get(url, { params: payload })
      .then(response => {
        callback(response.data)
      })
      .catch(err => {
        console.error(err)
      })
  },
  /**
     * @summary Model List 수정
     * @description
     * @param TN_FD_MODEL_.. List
     */
  putSetPointModel: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/setpoint-model')

    const result = await axios
      .put(url, payload.dataList)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
   * @summary lotsApply - Storage 데이터 조회
   */
  getSetPointDatas: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/setpoint-model/datas')

    const result = await axios
      .post(url, payload.dataList)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
   * @summary AutoSpec 계산(SetPoint)
   */
  runSetPointAutoSpec: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/setpoint-model/auto-spec')

    const result = await axios
      .post(url, payload.dataList)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },

  /**
   * Formula Model
   */
  getFormulaModel: async (payload, callback) => {
    let url = config().url.concat(config().port, config().service, '/formula-model')

    await axios
      .get(url, { params: payload })
      .then(response => {
        callback(response.data)
      })
      .catch(err => {
        console.error(err)
      })
  },
  /**
   * @summary Model List 조회
   * @description  PK중에 RECIPE_ID, STEP_ID는 Default 값 'ALL'로 설정
   * @param fab 장소
   * @param eqpId 장비 ID
   * @param moduleId 모듈 ID
   * @param modelType UVA, MVA 구분
   * @param uvaType UVA 타입(SETPOINT, FORMULA) UVA일때만
   */
  getUvaModels: async (payload) => {
    // getFormulaModels
    const url = config().url.concat(config().port, config().service, '/uva-models')

    const result = await axios
      .get(url, { params: payload })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.error(err)
      })
    return result
  },
  /**
   * @summary lotsApply - Storage 데이터 조회
   */
  getFormulaDatas: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/formula-model/datas')

    const result = await axios
      .post(url, payload.dataList)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
   * @summary calcScriptData - formula detection script data LinearRegression 결과 return
   */
  getFormulaScript: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/formula-model/script')

    const result = await axios
      .post(url, payload.dataList)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
   * @summary AutoSpec 계산(Formula)
   */
  runFormulaAutoSpec: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/formula-model/auto-spec')

    const result = await axios
      .post(url, payload.dataList)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
   * @summary Script Validation
   */
  runFormulaValid: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/formula-model/valid')

    const result = await axios
      .post(url, payload.dataList)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
  * @summary Model List 조회
  * @description  PK중에 RECIPE_ID, STEP_ID는 Default 값 'ALL'로 설정
  * @param fab 장소
  * @param eqpId 장비 ID
  * @param moduleId 모듈 ID
  * @param paramName Model Name
  */
  getModelParams: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/params')

    const result = await axios
      .get(url, { params: payload })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.error(err)
      })
    return result
  },
  /**
     * @summary Model List 수정
     * @description
     * @param TN_FD_MODEL_.. List
     */
  putPormulaModel: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/formula-model')

    const result = await axios
      .put(url, payload.dataList)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },

  /**
   * Multivariate Model
   */
  getMvaModel: async (payload, callback) => {
    let url = config().url.concat(config().port, config().service, '/mva-model')

    await axios
      .get(url, { params: payload })
      .then(response => {
        callback(response.data)
      })
      .catch(err => {
        console.error(err)
      })
  },
  /**
   * @summary Model List 조회
   * @description  PK중에 RECIPE_ID, STEP_ID는 Default 값 'ALL'로 설정
   * @param fab 장소
   * @param eqpId 장비 ID
   * @param moduleId 모듈 ID
   * @param modelType UVA, MVA 구분
   * @param uvaType UVA 타입(SETPOINT, FORMULA) UVA일때만
   */
  getMvaModels: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/mva-models')

    const result = await axios
      .get(url, { params: payload })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.error(err)
      })
    return result
  },

  /**
   * Detection Common Component
   * @param {*} payload
   * @returns
   */
  /**
   * @summary Model List 등록
   * @description
   * @param TN_FD_MODEL_.. List
   */
  addMvaModel: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/mva-model')

    const result = await axios
      .post(url, payload.dataList)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
   * @summary Model List 등록
   * @description
   * @param TN_FD_MODEL_.. List
   */
  addUvaModel: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/uva-model')

    const result = await axios
      .post(url, payload.dataList)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
   * @summary Model List 삭제
   * @description
   * @param TN_FD_MODEL_.. List
   */
  deleteMvaModel: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/mva-model/delete')

    const result = await axios
      .post(url, payload.dataList)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
   * @summary Model List 삭제
   * @description
   * @param TN_FD_MODEL_.. List
   */
  deleteUvaModel: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/uva-model/delete')

    const result = await axios
      .post(url, payload.dataList)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
   * @summary Model Condition List 조회
   * @description  PK중에 RECIPE_ID, STEP_ID는 Default 값 'ALL'로 설정
   * @param fab
   * @param eqpId
   * @param moduleId
   * @param recipeId
   * @param stepId
   * @param modelType UVA, MVA
   */
  getModelConditions: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/model-conditions')

    const result = await axios
      .get(url, { params: payload })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.error(err)
      })
    return result
  },
  /**
    * @summary Model Condition List 저장
    * @description
    * @param TN_FD_MODEL_COND List
  */
  saveModelConditions: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/model-conditions')
    const result = await axios
      .post(url, payload)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
    * @summary Model Condition List 삭제
    * @description
    * @param TN_FD_MODEL_COND List
  */
  deleteModelConditions: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/model-conditions/delete')
    const result = await axios
      .post(url, payload)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
    * @summary Model Condition Key validation
    * @description
    * @param TN_FD_MODEL_COND PK
  */
  getModelConditionValid: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/model-conditions/valid')
    const result = await axios
      .get(url, { params: payload })
      .then(response => {
        return response.data
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
    * @summary COND_SEQ MAX+1 value
    * @description
    * @param TN_FD_MODEL_COND PK
  */
  getModelConditionMaxSeq: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/model-conditions/max-seq')
    const result = await axios
      .get(url, { params: payload })
      .then(response => {
        return response.data
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },

  /**
   * SPC Rule
   */
  /**
   * SPC Rule List 조회
   * @param {String} payload customYn
   * @returns
   */
  getSpcRules: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/spc/rules', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  /**
   * SPC Rule 등록 및 수정
   * @param {Array} payload SPC Rule 정보
   * @returns
   */
  saveSpcRule: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + config().service + '/spc/rule', payload)
      return response === null ? [] : response
    } catch (error) {
      console.log(error)
    }
  },
  // FIXME: REST DELETE로 수정 필요(deleteMapping의 경우 requestBody를 지원하지 않는 문제로 인해 post 방식 유지중)
  /**
   * SPC Rule 삭제
   * @param {Array} payload 삭제할 SPC Rule Row
   * @returns
   */
  deleteSpcRules: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + config().service + '/spc/rules', payload)
      return response === null ? [] : response
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * SPC Model
   */
  /**
   * @summary       : Get SPC Mail Group List
   * @description   : Mail Search
   */
  getSpcMailGroups: async () => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/spc/mail-groups')
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  getSpcModels: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/spc/models', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  /**
   * @summary Model List 등록
   * @description
   * @param TN_FD_MODEL_.. List
   */
  saveSpcModels: async (payload) => {
    const url = config().url + config().port + config().service + '/spc/models'

    const result = await axios
      .post(url, payload.dataList)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  getSpcModelRules: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/spc/model-rules', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  saveSpcModelRules: async (payload) => {
    const url = config().url + config().port + config().service + '/spc/model-rules'

    const result = await axios
      .post(url, payload)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  deleteSpcModelRules: async (payload) => {
    const url = config().url + config().port + config().service + '/spc/model-rules/delete'

    const result = await axios
      .post(url, payload)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
   * @summary Auto Spec
   * @description
   * @param TN_FD_MODEL_.. List
   */
  getSpcModelAutoSpec: async (payload) => {
    // console.log('getAutoSpec')
    const url = config().url + config().port + config().service + '/spc/model-auto-spec'

    const result = await axios
      .post(url, payload)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
   * @summary Simulation
   * @description
   * @param TN_FD_MODEL_.. List
   */
  runSpcModelSimulation: (payload) => {
    // console.log('getSimulation')
    const url = config().url + config().port + config().service + '/spc/model-simulation/run'

    const result = axios
      .post(url, payload)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
   * @summary Save Simulation
   * @description
   * @param TN_FD_MODEL_.. List
   */
  saveSpcModelSimulation: async (payload) => {
    // console.log('saveSimulationData')
    const url = config().url + config().port + config().service + '/spc/model-simulation'

    const result = await axios
      .post(url, payload)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },

  /**
   * Analysis
   */
  getSpcModels2: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/spc/models2', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  getSpcExtraSummaryTypes: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/spc/extra-summary-types', { params: payload })
      let result = response.data === null ? [] : response.data
      result = result.map(data => ({
        checked: false,
        smryType: data
      }))

      return result
    } catch (error) {
      console.log(error)
    }
  },
  /**
   * @summary       : Get SPC Mail Group List
   * @description   : Mail Search
   */
  getMailGroupList: async () => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/spc/mail-groups')
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  /**
   * @summary       : Save SPC Mail Group List
   * @description   : Mail Group Save
   * @Param         : emailGroupId(PK)
   * @Param         : emailGroupDesc
   */
  saveMailGroup: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/spc/mail/group/save', payload)
      return response === null ? [] : response
    } catch (error) {
      console.log(error)
    }
  },
  /**
   * @summary       : Delete SPC Mail Group List
   * @description   : Mail Group Delete
   * @Param         : emailGroupId(PK)
   */
  deleteMailGroup: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/spc/mail/group/delete', payload)
      return response === null ? [] : response
    } catch (error) {
      console.log(error)
    }
  },
  /**
   * @summary       : Get SPC Mail Group User List
   * @description   : Mail Search
   * @Param         : eamilGropupId(PK)
   */
  getMailGroupUserList: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + '/fdc/spc/mail/user/list', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  /**
   * @summary       : Save SPC Mail Group User List
   * @description   : Mail Group User Save
   * @Param         : emailGroupId(PK)
   * @Param         : emailAddr(PK)
   */
  saveMailGroupUser: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/spc/mail/user/save', payload)
      return response === null ? [] : response
    } catch (error) {
      console.log(error)
    }
  },
  /**
   * @summary       : Delete SPC Mail Group User List
   * @description   : Mail Group User Delete
   * @Param         : emailGroupId(PK)
   * @Param         : emailAddr(PK)
   */
  deleteMailGroupUser: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/spc/mail/user/delete', payload)
      return response === null ? [] : response
    } catch (error) {
      console.log(error)
    }
  }
}
